/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 */

import React from 'react';
import ResetFilterComponent from './ResetFilterComponent.jsx';
import DurationInputComponent from './DurationInputComponent.jsx';
import ToolTip from '../../common/ToolTip.js';

class NumericRangeComponent extends React.Component {
  constructor(props) {
    super(props);
    let Dyn = this.props.Dyn;
    /**
     * set the range using leftNumber and rightNumber from attribute statsPreFilter
     * and initial values for the indicators by reading it from attribute stats
     * Its based on the range calculated by the scale
     */
    var filter = Dyn.dataSet.caseFilter.getAttributeFilter( this.props.attributeObj.id ),
        currentMin = (filter?.numeric) ? filter.numeric.min : this.props.attributeObj.statsPreFilter.min,
        currentMax = (filter?.numeric) ? filter.numeric.max : this.props.attributeObj.statsPreFilter.max;
    this.state = {
      leftNumberTemp: currentMin,
      rightNumberTemp: currentMax,
      leftNumber: currentMin,//this.props.attributeObj.statsPreFilter.min,
      rightNumber: currentMax,//this.props.attributeObj.statsPreFilter.max,
      storedNumber: currentMin
    };
  }

  /**
   * A function that takes two arguments, the first representing the x-position of the slider and
   * the second the width of the slider. Use this to control the mapping of the domain of numbers
   * the slider represents onto the range of pixel locations of the slider. By default,
   * this is set to the non-linear - It can be specified in the slider configuration
   */
  scalingFunction = (x, constantBase) => {

    // return Math.pow(x, 2) / Math.pow(constantBase, 2);
  }

  // Typed conditions cannot go out of bounds, but they can cross
  typedConditionsMet = (state) => {

    // left needs to be less than right
    return state.leftNumber <= state.rightNumber;
  }

  getOtherDirection = (thisDirection) => {

    var directions = ["left", "right"];
    var otherIndex = (directions.indexOf(thisDirection) + 1) % 2;
    return directions[otherIndex];
  }

  onChange = (val, className ) => {
    var stateObject = {};
    stateObject[this.getFixedClassName(className)] = val;
    this.setState(stateObject, () => {
        this.actualOnChange(className);
    });
  }

  getFixedClassName = (className) => {
    if(className.indexOf("leftNumber") >= 0) {
      return "leftNumber";
    } else if(className.indexOf("rightNumber") >= 0) {
      return "rightNumber";
    }
  }

  actualOnChange = (className) => {

    var   stateObject = {},
      targetClassName = this.getFixedClassName(className),
            direction = targetClassName.match(/(\w+)Number/)[1],
       otherDirection = this.getOtherDirection(direction),
           targetValue = this.state[targetClassName] + "";

    // Restrictions on entered values. Storage of temporary value when user clears
    // input field.
    //if ( targetValue.match(/^\d+$/) ){ //&& targetValue <= this.props.rightNumber && targetValue >= this.props.leftNumber)
    // targetValue.match(/^[-+]?(\d+\.?|\d*\.\d+)$/)
    // targetValue.match(/^-?[0-9]\d+(\.\d*)?$/)
    if( targetValue.match(/^[-+]?(\d+\.?|\d*\.\d+)$/) ) {
      stateObject[targetClassName + "Temp"] = stateObject[targetClassName] = Number(targetValue);
    } else if (targetValue === "") {
      stateObject[targetClassName] = "";
      stateObject.storedNumber = this.state[targetClassName + "Temp"];
      this.setState(stateObject);
      return;
    } else {
      stateObject[targetClassName] = this.state[targetClassName + "Temp"];
      this.setState(stateObject);
      return;
    }

    var otherNumber = otherDirection + "Number",
        wrongInput = false;
    stateObject[otherNumber] = this.state[otherNumber];
    if (!this.typedConditionsMet(stateObject)){
      // if left is not less than right, don't do anything
      // highlight the item.
      wrongInput = true;
      // stateObject[otherNumber] = stateObject[targetClassName];
    }

    // stateObject = this.addPositionsFromNumbers(stateObject);
    this.setState(stateObject);

    if( !wrongInput ){
      // mediator.publish( "records:caseFilterByAttribute",{
      //   "attributeID": this.props.attributeObj.id,
      //   "numeric":{
      //     "min": stateObject.leftNumber,
      //     "max": stateObject.rightNumber
      //   }
      // } );

      // message to parent to rerender
      this.props.handleChange({
          filterChanged: true,
          dataType: 'numerical',
          component: 'numeric-range',
          filtered: {
              min: stateObject.leftNumber,
              max: stateObject.rightNumber
          }
      });
    }
  }

  onFocus = ( e ) => {

    // make the insert left align
    var   stateObject = {},
      targetClassName = this.getFixedClassName(e.target.className),
            direction = targetClassName,
                value = e.target.value;
    stateObject[targetClassName] = '';
    stateObject.storedNumber = this.state[targetClassName];
    this.setState(stateObject);
  }

  getLoc = (str) => {
    let Dyn = this.props.Dyn;
      return Dyn.loc( str );
  }

  render = () => {

    var leftNumber = this.state.leftNumber,
        rightNumber = this.state.rightNumber;

    if( this.props.resetFilter ){
      leftNumber = this.props.attributeObj.statsPreFilter.min;
      rightNumber = this.props.attributeObj.statsPreFilter.max;
    }

    // checking if while converting from categorical to numerical if there is
    // no valid numeric value.
    if( typeof(leftNumber) === 'undefined' || typeof(rightNumber) === 'undefined')
    {
      return (
        <div className="tde-numeric-component">
          <div className="tde-m-2 tde-text-error">{this.getLoc('No valid numeric value for the attribute.')}</div>
        </div>
      );
    } else {
      return (
        <div className="tde-numeric-component tde-pt-4 tde-mt-4 tde-divider-top">
            <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                <div className="tde-row">
                    <div className="tde-s1 tde-font-weight-bold tde-attr-name tde-mb-2">
                    { this.getLoc('Filter Range') } <ToolTip tip={this.getLoc('Set minimum and maximum values')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip>
                    {this.props.isFiltered && <ResetFilterComponent value={ this.getLoc('Reset') } handleChange={this.props.handleChange} attributeObj={ this.props.attributeObj } isFiltered={ this.props.isFiltered }/>}
                    </div>
                </div>
                <div className="tde-row tde-my-2">
                    <div className="tde-label tde-mb-2">{ this.getLoc('Min') }</div>
                    <DurationInputComponent className="tde-input tde-input-text"
                        onChange={(val) => this.onChange(val, 'leftNumber')}
                        // onBlur={this.onBlur}
                        arialabel={'Minimum Filter Range Value'}
                        Dyn={this.props.Dyn}
                        attributeObj={this.props.attributeObj}
                        value={leftNumber} />
                </div>
                <div className="tde-row tde-my-2">
                    <div className="tde-label tde-mb-2">{ this.getLoc('Max') }</div>
                    <DurationInputComponent className="tde-input tde-input-text"
                        onChange={(val) => this.onChange(val, 'rightNumber')}
                        // onBlur={this.onBlur}
                        arialabel={'Maximum Filter Range Value'}
                        Dyn={this.props.Dyn}
                        attributeObj={this.props.attributeObj}
                        value={rightNumber} />
                </div>
            </div>
        </div>
      );
    }
  }
}

export default NumericRangeComponent
